import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledHeader = styled.section`
  padding-top: 60px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;
